var _script, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaLogirus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: "",
    async: "false",
    type: "text/javascript",
    src: "moz-extension://33d4f970-0f6d-4e56-ae9a-a8614e04c84f/in-page.js"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_390_6)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11H239V240H10V11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3555 210.482H146.99V191.858H73.5307V38.5628H51.3555V210.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.465 172.098H132.592V114.606H148.728C164.285 115.21 171.363 122.094 175.3 140.405C179.093 156.928 181.991 168.16 184.165 172.098H201.872C199.118 166.976 195.978 154.174 191.63 135.67C188.489 121.901 182.378 112.456 172.16 108.905V108.301C186.122 103.47 197.161 91.9717 197.161 74.4826C197.316 69.7822 196.466 65.1028 194.666 60.7577C192.866 56.4126 190.159 52.502 186.726 49.2878C178.44 41.7993 166.628 38.4416 148.318 38.4416C137.305 38.3468 126.308 39.2687 115.465 41.1956V172.122V172.098ZM132.592 53.2011C138.142 51.9799 143.821 51.4444 149.501 51.6068C167.618 51.8242 180.035 59.2885 180.035 76.4152C180.035 91.5851 168.416 101.61 150.105 101.61H132.592V53.2978V53.2011Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_390_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 229,
    height: 229,
    fill: "white",
    transform: "translate(10 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaLogirus);
export default __webpack_public_path__ + "static/media/media_logirus.c5141b9674d27bb0280983eb390b500b.svg";
export { ForwardRef as ReactComponent };